import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.extra.common.FaFunction.Type,
    graphql.schema.FaFunctionType
  >({
    [ents.extra.common.FaFunction.Type.Facilities]:
      graphql.schema.FaFunctionType.Facilities,
    [ents.extra.common.FaFunction.Type.Administration]:
      graphql.schema.FaFunctionType.Administration,
    [ents.extra.common.FaFunction.Type.Direct]:
      graphql.schema.FaFunctionType.Direct,
  }),
  graphql.transformers.OUT.enumeration<
    graphql.schema.FaFunctionType,
    ents.extra.common.FaFunction.Type
  >({
    [graphql.schema.FaFunctionType.Facilities]:
      ents.extra.common.FaFunction.Type.Facilities,
    [graphql.schema.FaFunctionType.Administration]:
      ents.extra.common.FaFunction.Type.Administration,
    [graphql.schema.FaFunctionType.Direct]:
      ents.extra.common.FaFunction.Type.Direct,
  }),
)
